import { Typography } from "antd";
import { useEffect, useState } from "react";
import {
  getRefundTransactionLogsByRefund,
  getRefundTransactions,
} from "../../../apis/po.api";

export interface RefundTransactionsProps {
  refundId: any;
}

export function RefundTransactions({ refundId }: RefundTransactionsProps) {
  const [transactions, setTransactions] = useState([] as any[]);
  const [transactionLogs, setTransactionLogs] = useState(
    {} as Record<string, any>
  );

  useEffect(() => {
    if (!refundId) {
      console.error("Refund ID is required to fetch transactions.");
      return;
    }

    getRefundTransactions(refundId)
      .then((response) => {
        setTransactions(response);
        getRefundTransactionLogsByRefund(refundId).then((allLogs: any[]) => {
          const grouped: Record<string, any[]> = {};
          (response || []).forEach((t: any) => {
            if (t?.id != null) grouped[t.id] = [];
          });
          (allLogs || []).forEach((log: any) => {
            const tid = log?.refund_transaction?.id;
            if (tid == null) return;
            (grouped[tid] ||= []).push(log);
          });
          setTransactionLogs((prev) => ({ ...prev, ...grouped }));
        });
      })
      .catch((error) => {
        console.error("Error fetching refund transactions:", error);
      });
  }, [refundId]);

  return (
    <div>
      <div>
        <div className="th-fontSize-12 th-fontWeight-300 mb-1">
          Current Status
        </div>
        <Typography.Title level={3} style={{ textTransform: "capitalize" }}>
          {transactions.length > 0 ? transactions[0].status : "No transactions"}
        </Typography.Title>
      </div>
      <div className="mt-4">
        <Typography.Title level={4}>Transactions</Typography.Title>
        {transactionLogs[transactions[0]?.id]?.map((log: any) => (
          <div key={log?.id} className="mb-3">
            <Typography.Text strong>Log ID: #{log?.id}</Typography.Text>
            <div className="d-flex gap-2">
              <div className="th-fontSize-12 th-fontWeight-300 flex-grow-1">
                <b>Status:</b>
                <br />
                {log?.status}
              </div>
              <div className="th-fontSize-12 th-fontWeight-300 flex-grow-1">
                <b>Date Time:</b>
                <br />
                {new Date(log?.created_at).toLocaleString()}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
